<template>
  <b-sidebar
    id="add-new-departement-sidebar"
    :visible="isAddNewDepartementSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="hideSidebar"
    @change="val => $emit('update:is-add-new-departement-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Add New Departement
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <validation-observer
ref="refFormObserver"
#default="{ invalid }"
>
        <b-form
          class="p-2"
          @submit.prevent="addNewDepartement"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="Departement Name"
            rules="required"
          >
            <b-form-group
              label="Departement Name"
              label-for="DepartementName"
            >
              <b-form-input
                id="DepartementName"
                v-model="departementData.departementName"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="Departement Name"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              block
              :disabled="invalid || submitButtonDisabled"
            >
              Add
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hideSidebar"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import axios from 'axios'
import { ref } from '@vue/composition-api'
import moment from 'moment-timezone'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiEndpoints from '@/constants/apiEndpoints'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewDepartementSidebarActive',
    event: 'update:is-add-new-departement-sidebar-active',
  },
  props: {
    isAddNewDepartementSidebarActive: {
      type: Boolean,
      required: true,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      submitButtonDisabled: false,
      required,
    }
  },
  setup() {
    const blankDepartementData = {
      departementName: '',
    }
    const departementData = ref(JSON.parse(JSON.stringify(blankDepartementData)))

    const resetDepartementData = () => {
      departementData.value = JSON.parse(JSON.stringify(blankDepartementData))
    }

    const { refFormObserver, getValidationState, resetForm } = formValidation(resetDepartementData)

    return {
      departementData,
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
  methods: {
    hideSidebar() {
      this.$emit('update:is-add-new-departement-sidebar-active', false)
      this.resetForm()
    },
    addNewDepartement() {
      this.$refs.refFormObserver.validate().then(success => {
        if (!success) return

        this.submitButtonDisabled = true
        const userToken = this.$cookies.get('userToken')
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userToken}`,
        }

        const payload = {
          departement_name: this.departementData.departementName,
          time: moment().format(),
        }

        axios
          .post(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_ADD_DEPARTEMENTS}`, payload, { headers })
          .then(response => {
            this.submitButtonDisabled = false
            if (response.data.success === true) {
              this.hideSidebar()
              this.$root.$emit('refreshTable', 'refreshTable')
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Success',
                  icon: 'CheckIcon',
                  variant: 'success',
                  text: 'Departement has been successfully added!',
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Notification',
                  icon: 'BellIcon',
                  variant: 'danger',
                  text: response.data.message || 'Something went wrong',
                },
              })
            }
          })
          .catch(error => {
            console.error(error)
            this.submitButtonDisabled = false
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Error',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                text: 'Something went wrong',
              },
            })
          })
      })
    },
  },
}
</script>

<style lang="scss">
#add-new-departement-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>